import { memo } from 'react';

import { cn } from 'src/lib/utils';

import type { SVGProps } from 'react';
const SvgIconBeneficiaryH = (props: SVGProps<SVGSVGElement>) => {
  const { className } = props;
  const svgClasses = cn('ck-icon', className);
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      role="img"
      className={svgClasses}
    >
      <path
        fill="currentColor"
        d="M3.367 15.416c.745 0 1.464.324 1.972.89l2.64 2.938c.341-1.137 1.366-1.966 2.573-1.966h4.149c.581 0 1.141-.219 1.577-.617a6.13 6.13 0 0 1 8.238-.059 2.67 2.67 0 0 1 2.202-1.186h3.712c.496 0 .898.417.898.931v11.175c0 .514-.402.931-.898.931h-3.712c-.807 0-1.531-.37-2.025-.954l-.532.155c-1.819.53-3.7.799-5.59.799h-8.019c-1.968 0-3.848-.975-5.029-2.608l-4.312-5.961a2.84 2.84 0 0 1-.538-1.675c0-1.54 1.209-2.794 2.694-2.794zM25.819 25.66c0 .513.403.931.898.931h2.814v-9.312h-2.814c-.495 0-.898.418-.898.931zM2.648 18.767l4.312 5.961c.844 1.166 2.186 1.862 3.592 1.862h8.019a18.2 18.2 0 0 0 5.103-.73l.351-.102-.003-.099V18.63l-.626-.571a4.38 4.38 0 0 0-5.933 0 4.1 4.1 0 0 1-2.764 1.081H10.55c-.495 0-.898.418-.898.931s.403.931.898.931h6.383c.496 0 .898.417.898.931s-.402.931-.898.931H9.948a2.66 2.66 0 0 1-1.971-.89l-3.954-4.401a.88.88 0 0 0-.657-.297c-.495 0-.898.418-.898.931 0 .203.062.396.179.557zM17.704 3.627c-.344-.189-.763-.036-.935.343l-2.787 6.131c-.172.379-.032.839.312 1.028s.763.035.935-.343l2.787-6.131c.172-.378.033-.839-.312-1.028M12.313 3.771a.653.653 0 0 0-.985 0L8.541 6.836a.82.82 0 0 0 0 1.084l2.787 3.065c.272.299.713.299.985 0s.272-.784 0-1.084l-2.294-2.524 2.294-2.524a.82.82 0 0 0 0-1.084zM19.687 3.771a.653.653 0 0 1 .985 0l2.787 3.065a.82.82 0 0 1 0 1.084l-2.787 3.065c-.272.299-.713.299-.985 0s-.272-.784 0-1.084l2.294-2.524-2.294-2.524a.82.82 0 0 1 0-1.084z"
      />
    </svg>
  );
};
const Memo = memo(SvgIconBeneficiaryH);
export default Memo;
